<template>
    <span>
        <!-- 这里可以使用v-if  但是会报红色波浪线  注：for的优先级比if高 从编译的源码可以得知 -->
        <i
            class="iconBg"
            v-for="(item, index) in paramsArray[0]"
            :key="index"
            v-show="(item === '1' || item === '0') && titleIconFn(item, 'icon', index)"
            :class="titleIconFn(item, 'icon', index)"
            :title="titleIconFn(item, 'text', index)"
            @click="handleClickIcon(item, index)"
        ></i>
        <IconDialog :isShow.sync="isShow" :title="title" :tableData="tableData" :isRegin="isRegin" />
    </span>
</template>

<script>
import IconDialog from './IconDialog.vue';
import { exEecords } from '@/api/modules/abnormal.js';
export default {
    props: ['rowData', 'isShowEdit2'],
    components: {
        IconDialog
    },
    data() {
        return {
            paramsArray: [],
            abnormalArray: [
                {
                    id: '1',
                    text: $t('integration.abnormal_sensor_connection'),
                    icon: 'el-icon-warning'
                },
                {
                    id: '2',
                    text: $t('integration.abnormal_sensor_temperature'),
                    icon: 'el-icon-error'
                },
                {
                    id: '3',
                    text: $t('integration.abnormal_sensor_humidity'),
                    icon: 'el-icon-warning-outline'
                },
                {
                    id: '4',
                    text: $t('integration.gateway_connection_exception'),
                    icon: 'el-icon-circle-close'
                },
                {
                    id: '5',
                    text: $t('integration.gateway_power_failure_exception'),
                    icon: 'el-icon-close'
                },
                {
                    id: '6',
                    text: $t('integration.abnormal_connection_of_display_screen'),
                    icon: 'el-icon-no-smoking'
                },
                {
                    id: '7',
                    text: $t('integration.abnormal_relay_connection'),
                    icon: 'el-icon-s-operation'
                },
                {
                    id: '8',
                    text: $t('integration.retention_exception'),
                    icon: 'el-icon-message-solid'
                }
            ],
            detailRow: {},
            isShow: false,
            title: '',
            listQuery: {
                iDisplayStart: 0,
                iDisplayLength: 15,
                exId: null,
                exType: null
            },
            tableData: [],
            isRegin: false
        };
    },
    mounted() {
        if (this.rowData['ex_mark_reserve_str']) {
            this.paramsArray.push(this.rowData['ex_mark_reserve_str'].split('').reverse());
        }
        this.detailRow = { ...this.rowData };
    },
    methods: {
        titleIconFn(item, str, index) {
            if (index >= 7) return;
            if (item === '0') return;
            if (item === '1') {
                return this.abnormalArray[index][str];
            }
            // return item === '0'? this.abnormalArray[index].icon:''
        },
        handleClickIcon(item, index) {
            // if (this.isShowEdit2) return this.$message.warning($t('integration.currently_in_view_mode_c__unable_to_process'))
            const { carrier_name, happen_time } = this.detailRow;
            this.isShow = true;
            this.title = `[${carrier_name}]-[${this.$timetransition(happen_time)}]-[${this.abnormalArray[index].text}]`;
            this.listQuery.exId = this.rowData['id'];
            this.listQuery.exType = this.abnormalArray[index].id;
            if (index === 1 || index === 2) {
                this.isRegin = false;
            } else {
                this.isRegin = true;
            }
            this.abnormalList();
        },
        abnormalList() {
            exEecords(this.listQuery).then(({ result }) => {
                this.tableData = result;
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.iconBg {
    width: 20px;
    height: 20px;
    line-height: 20px;
    text-align: center;
    // background-color: #e7e7e7;
    cursor: pointer;
    &:hover {
        // background-color: #fff;

        color: red !important;
        font-weight: bold;
    }
    .noallow {
        cursor: not-allowed;
    }
}
</style>
